// src/Home.js (SIMPLIFIÉ - Contient UNIQUEMENT les sections uniques)
import React from 'react';
import { useTranslation } from 'react-i18next';
// Nous n'avons plus besoin de Link, FaIcons, LanguageSwitcher ici
// Ces éléments sont maintenant dans Layout.js

function Home() { 
  const { t } = useTranslation();
  
  // NOTE: Les liens de navigation sont maintenant dans Layout.js et n'ont pas besoin d'être ici
  
  return (
    // Nous retirons la balise <div> avec la classe 'app' si elle enveloppait le header/footer
    <>
      {/* Hero Section */}
      <section className="hero">
        <h2>{t('hero_title')}</h2>
        <div className="stats">{t('hero_stats')}</div>
        <div className="subtitle">{t('hero_subtitle')}</div>

        {/* Nous retirons ici le bouton Login/View Picks car ils sont dans le Header du Layout */}
      </section>

      {/* Subscription Plans */}
      <section className="plans">
        <h3>{t('plans_title')}</h3>

        <div className="plan-cards">
          {/* YEARLY */}
          <div className="plan-card">
            <h4>{t('vip_yearly')}</h4>
            <div className="price">
              {t('price_yearly')}<span>{t('unit_yearly')}</span>
            </div>
            <div className="description">{t('desc_yearly')}</div>
            <ul>
              <li>{t('benefit1')}</li>
              <li>{t('benefit2')}</li>
            </ul>
            <button
              className="subscribe-btn"
              onClick={() =>
                window.open(
                  "https://buy.stripe.com/test_3cI4gtf1u1AYfLL3FpcAo06",
                  "_blank"
                )
              }
            >
              {t('btn_subscribe')}
            </button>
          </div>

          {/* SIX MONTHS */}
          <div className="plan-card">
            <h4>{t('vip_six_months')}</h4>
            <div className="price">
              {t('price_six_months')}<span>{t('unit_six_months')}</span>
            </div>
            <div className="description">{t('desc_six_months')}</div>
            <ul>
              <li>{t('benefit1')}</li>
              <li>{t('benefit2')}</li>
            </ul>
            <button
              className="subscribe-btn"
              onClick={() =>
                window.open(
                  "https://buy.stripe.com/test_aFa6oBg5y2F2gPPek3cAo05",
                  "_blank"
                )
              }
            >
              {t('btn_subscribe')}
            </button>
          </div>

          {/* MONTHLY */}
          <div className="plan-card">
            <h4>{t('vip_monthly')}</h4>
            <div className="price">
              {t('price_monthly')}<span>{t('unit_month')}</span>
            </div>
            <div className="description">{t('desc_monthly')}</div>
            <ul>
              <li>{t('benefit1')}</li>
              <li>{t('benefit2')}</li>
            </ul>

            <button
              className="subscribe-btn"
              onClick={() =>
                window.open(
                  "https://buy.stripe.com/test_14A9AN4mQ0wUfLL3FpcAo04",
                  "_blank"
                )
              }
            >
              {t('btn_subscribe')}
            </button>
          </div>

          {/* WEEKLY */}
          <div className="plan-card">
            <h4>{t('vip_weekly')}</h4>
            <div className="price">
              {t('price_weekly')}<span>{t('unit_week')}</span>
            </div>
            <div className="description">{t('desc_weekly')}</div>
            <ul>
              <li>{t('benefit1')}</li>
              <li>{t('benefit2')}</li>
            </ul>

            <button
              className="subscribe-btn"
              onClick={() =>
                window.open(
                  "https://buy.stripe.com/test_7sYfZb3iM4Na7ffek3cAo03",
                  "_blank"
                )
              }
            >
              {t('btn_subscribe')}
            </button>
          </div>

          {/* DAILY */}
          <div className="plan-card">
            <h4>{t('vip_daily')}</h4>
            <div className="price">
              {t('price_daily')}<span>{t('unit_day')}</span>
            </div>
            <div className="description">{t('desc_daily')}</div>
            <ul>
              <li>{t('benefit1')}</li>
              <li>{t('benefit2')}</li>
            </ul>

            <button
              className="subscribe-btn"
              onClick={() =>
                window.open(
                  "https://buy.stripe.com/test_4gMfZbdXqbbybvv3FpcAo02",
                  "_blank"
                )
              }
            >
              {t('btn_subscribe')}
            </button>
          </div>

        </div>
      </section>
    </>
  );
}

export default Home;